import React, { useState, useEffect } from "react";
import "./clients.scss";

//Services
import * as ClientService from "../../api/clients";
import * as RegionService from "../../api/Regiones";

//Iconos
import { ExclamationDiamond } from "react-bootstrap-icons";

//Components
import CellRenderEstatus from "../../components/Grids/estatus-grid/estatus-grid";
import CellRenderIconsGrids from "../../components/Grids/icons-grid/icons-grid";

//Items DevExpress
import { Toast } from "devextreme-react/toast";
import { Button } from "devextreme-react/button";
import { TextArea } from "devextreme-react/text-area"; // No eliminar, sin esto no funciona el input textarea aunque no se use la variable
import ScrollView from "devextreme-react/scroll-view";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { Tabs, Item as TabItem } from "devextreme-react/tabs";

import DataGrid, {
  Pager,
  Paging,
  Column,
  FilterRow,
  HeaderFilter,
  StateStoring,
  ColumnChooser,
  Export,
} from "devextreme-react/data-grid";

import Form, {
  SimpleItem,
  GroupItem,
  RequiredRule,
} from "devextreme-react/form";
import { SelectBox } from "devextreme-react";
import { NumberBox } from "devextreme-react/number-box";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [clientForm, setClientForm] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [selectedIdClient, setSelectedIdClient] = useState();
  const [msgPopup, setMsgPopup] = useState("Agregar Cliente");
  const [showPopupDelete, setShowPopupDelete] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [regiones, setRegiones] = useState([]);

  const allowedPageSizes = [8, 12, 20];
  const validationMsg = "Este campo es requerido";

  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );

  useEffect(() => {
    console.log("AQUIII ");
    setClientForm({
      id: 0,
      nombre_cliente: "",
      rif: "",
      estatus: false,
      descripcion: "",
      cod_cliente: "",
      infoOp: [
        {
          establecimientos: 0,
          promotor: 0,
          supervisor: 0,
          regiones: "",
        },
      ],
    });
    getAllClients();
    getRegiones();
  }, []);

  const getRegiones = () => {
    RegionService.getRegion()
      .then((data) => {
        console.log("Regiones:", data);
        if (data.status === 200) {
          // Mapear las regiones para el SelectBox
          const regionesMapeadas = data.data.map((region) => ({
            text: region.nombre_region,
            value: region.nombre_region,
          }));
          setRegiones(regionesMapeadas);
        }
      })
      .catch((err) => {
        console.error("Error al cargar regiones:", err);
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: "Error al cargar las regiones",
          isVisible: true,
        });
      });
  };

  const getAllClients = () => {
    ClientService.getClients()
      .then((data) => {
        console.log(data);
        if (data.status === 200) {
          console.log(data.data);
          setClients(data.data);
        } else {
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err);
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
      });
  };

  // const getColumns = (data) => {
  //   let newColumns = [];

  //   const columns = Object.keys(data);
  //   columns.forEach(column => {
  //     let newCaption = column.split('_');
  //     let caption = '';
  //     newCaption.map(x=>{
  //       caption = caption + x.charAt(0).toUpperCase() + x.slice(1) + ' ';
  //     })

  //     const item = {
  //       field: column,
  //       caption: caption,
  //     }
  //     newColumns.push(item);
  //   })
  //   console.log(columns);
  //   console.log(newColumns);
  //   setColumnsGrid(newColumns);
  // }

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const openPopup = () => {
    setShowPopup(true);
  };

  const hidePopup = () => {
    console.log("Cerré popup");
    setShowPopup(false);
    setClientForm({
      id: 0,
      nombre_cliente: "",
      rif: "",
      estatus: false,
      descripcion: "",
      cod_cliente: "",
      infoOp: [
        {
          establecimientos: 0,
          promotor: 0,
          supervisor: 0,
          regiones: "",
        },
      ],
    });
    setMsgPopup("Agregar Cliente");
    setSelectedTabIndex(0);
  };

  const saveClient = () => {
    let form = { ...clientForm };

    // Preservar el cod_cliente al editar; generar uno estable (timestamp) al crear.
    // Antes se hacía `Math.random() * 2` en cada guardado, lo que corrompía el
    // cod_cliente/CLIENT_COD (en Firestore y en PG vía onWriteClientes) en cada edición.
    const isEditing = form.id !== undefined && form.id !== 0 && form.id !== "";
    const codRaw = isEditing ? form.cod_cliente : Date.now();
    form.cod_cliente = String(
      codRaw !== undefined && codRaw !== null && codRaw !== "" ? codRaw : Date.now()
    );

    form.estatus = form.estatus === false ? "inactivo" : "activo";

    // Asegurar que infoOp se envíe correctamente
    if (form.infoOp && Array.isArray(form.infoOp)) {
      // Filtrar filas vacías si es necesario, o enviar todas
      form.infoOp = form.infoOp.map((item) => ({
        establecimientos: item.establecimientos || 0,
        promotor: item.promotor || 0,
        supervisor: item.supervisor || 0,
        region: item.regiones || item.region || "",
        ult_act: new Date().toISOString(),
        user_act: JSON.parse(localStorage.getItem("userData")).uid || "",
      }));
    }

    console.log("Formulario a enviar:", form);
    ClientService.createUpdateClient(form)
      .then((data) => {
        console.log(data);
        if (data.status === 200) {
          setToastConfig({
            ...toastConfig,
            type: "success",
            message: "¡Guardado Exitosamente!",
            isVisible: true,
          });
          hidePopup();
          getAllClients();
        } else {
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err);

        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
          displayTime: 9000,
        });
      });
  };

  const editClient = (client) => {
    console.log("Edit ", client);
    client.estatus = client.estatus === "activo" ? true : false;
    // Asegurar que infoOp existe
    if (
      !client.infoOp ||
      !Array.isArray(client.infoOp) ||
      client.infoOp.length === 0
    ) {
      client.infoOp = [
        {
          establecimientos: 0,
          promotor: 0,
          supervisor: 0,
          regiones: "",
        },
      ];
    } else {
      // Mapear 'region' (del backend) a 'regiones' (para el formulario)
      client.infoOp = client.infoOp.map((item) => ({
        ...item,
        regiones: item.region || item.regiones || "",
      }));
    }
    setClientForm(client);
    setMsgPopup("Editar Cliente");
    openPopup();
  };

  const openDeletePopup = (id) => {
    setShowPopupDelete(true);
    console.log(id);
    setSelectedIdClient(id);
  };

  const hideDeletePopup = () => {
    setShowPopupDelete(false);
  };

  const deleteClient = () => {
    console.log("Delete ", selectedIdClient);

    ClientService.deleteClient(selectedIdClient)
      .then((response) => {
        console.log(response);
        setToastConfig({
          ...toastConfig,
          type: "success",
          message: "Cliente Eliminado exitosamente",
          isVisible: true,
        });

        getAllClients();
      })
      .catch((err) => {
        console.log(err);

        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
      });

    console.log(toastConfig);
    setSelectedIdClient(null);
    hideDeletePopup();
  };

  const saveButtonOptions = {
    icon: "check",
    text: "Guardar",
    onClick: saveClient,
  };

  // const cellRender = (data) => {
  //   return <div className='d-flex icons_grid'>
  //     <FontAwesomeIcon icon={faPencil} className="icon" onClick={()=>editClient(data.data)}></FontAwesomeIcon>
  //     <FontAwesomeIcon icon={faTrashCan} className="icon" onClick={()=>openDeletePopup(data.data.id)}></FontAwesomeIcon>
  //   </div>;
  // }

  const cellRenderDescription = (data) => {
    return <p style={{ whiteSpace: "normal" }}>{data.data.descripcion}</p>;
  };

  // const cellRenderEstatus = (data) =>{
  //   let value = data.data.estatus == 'activo' ? true : false;
  //   // return <CheckBox defaultValue={value} disabled={true}  onValueChanged={(e) => { onValueStatusChanged(e, data.data) }} />
  //   return <FontAwesomeIcon icon={faCircleCheck} className="icon-status"></FontAwesomeIcon>
  // }

  // const onValueStatusChanged = (e, data) => {
  //   data.estatus = e.value;
  //   saveClient(data);
  // }

  const agregarNuevaFila = () => {
    const newInfoOp = [...(clientForm.infoOp || [])];
    newInfoOp.push({
      establecimientos: 0,
      promotor: 0,
      supervisor: 0,
      regiones: "",
    });
    setClientForm({
      ...clientForm,
      infoOp: newInfoOp,
    });
  };

  const eliminarFila = (indexToDelete) => {
    const newInfoOp = (clientForm.infoOp || []).filter(
      (item, index) => index !== indexToDelete
    );
    // Asegurar que siempre haya al menos una fila
    if (newInfoOp.length === 0) {
      newInfoOp.push({
        establecimientos: 0,
        promotor: 0,
        supervisor: 0,
        regiones: "",
      });
    }
    setClientForm({
      ...clientForm,
      infoOp: newInfoOp,
    });
  };

  return (
    <React.Fragment>
      <div className="d-flex mt-4 mb-4">
        <div className="header-grid-title">
          <h5 className="content-block titleCliente">Clientes</h5>
        </div>
        <div className="header-grid-right">
          <Button onClick={openPopup} className="btn-agregar mt-4">
            {" "}
            + Crear Cliente
          </Button>
        </div>
      </div>
      <div className="tabla-Cliente">
        <DataGrid
          className="tabla-Cliente"
          dataSource={clients}
          showBorders={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          keyExpr="nombre_cliente"
          style={{ height: "400px" }}
        >
          <Export enabled={true} />
          <ColumnChooser enabled={true} mode="select" />
          <FilterRow visible={true} />
          <Paging defaultPageSize={10} />
          <Pager
            showPageSizeSelector={true}
            showInfo={true}
            allowedPageSizes={allowedPageSizes}
          />
          <HeaderFilter visible={true} />
          <Column
            width={150}
            caption="Rif "
            dataField="rif"
            dataType="string"
            sortOrder="asc"
          />
          <Column
            caption="Nombre"
            dataField="nombre_cliente"
            dataType="string"
          />
          <Column
            width={140}
            caption="Estatus "
            dataField="estatus"
            dataType="string"
            alignment="center"
            cellRender={CellRenderEstatus}
          />
          <Column
            width={250}
            caption="Descripción"
            dataField="descripcion"
            dataType="string"
            cellRender={cellRenderDescription}
          />
          <Column
            width={80}
            caption=""
            allowSorting={false}
            cellRender={(data) =>
              CellRenderIconsGrids(data, editClient, openDeletePopup)
            }
          />
        </DataGrid>
      </div>
      <Popup
        width={"50%"}
        height={"70%"}
        visible={showPopup}
        onHiding={hidePopup}
        showTitle={true}
        title={msgPopup}
        showCloseButton={true}
      >
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          options={saveButtonOptions}
        />
        <div
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <Tabs
            selectedIndex={selectedTabIndex}
            onSelectedIndexChange={setSelectedTabIndex}
            style={{ marginBottom: "20px" }}
          >
            <TabItem text="Datos Básicos" />
            <TabItem text="Información Adicional" />
          </Tabs>
          <ScrollView width="100%" height="100%">
            <div className="form-container">
              <Form formData={clientForm} key={selectedTabIndex}>
                <GroupItem
                  cssClass="second-group"
                  visible={selectedTabIndex === 0}
                >
                  <GroupItem colCount={2}>
                    <SimpleItem dataField="nombre_cliente">
                      <RequiredRule message={validationMsg} />
                    </SimpleItem>
                    <SimpleItem dataField="rif">
                      <RequiredRule message={validationMsg} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem
                    editorType="dxTextArea"
                    dataField="descripcion"
                  ></SimpleItem>
                  <SimpleItem
                    editorType="dxCheckBox"
                    dataField="estatus"
                  ></SimpleItem>
                </GroupItem>
                {(clientForm.infoOp || []).map((item, index) => (
                  <GroupItem
                    key={index}
                    visible={selectedTabIndex === 1}
                    style={{ marginBottom: "15px" }}
                  >
                    <SimpleItem
                      itemType="simple"
                      render={() => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                            gap: "10px",
                            width: "100%",
                          }}
                        >
                          {/* Campo Regiones */}
                          <div style={{ flex: "2 1 0", minWidth: "200px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              Regiones
                            </label>
                            <SelectBox
                              dataSource={regiones}
                              displayExpr="text"
                              valueExpr="value"
                              value={clientForm.infoOp?.[index]?.regiones || ""}
                              onValueChanged={(e) => {
                                const newInfoOp = [
                                  ...(clientForm.infoOp || []),
                                ];
                                newInfoOp[index] = {
                                  ...newInfoOp[index],
                                  regiones: e.value,
                                };
                                setClientForm({
                                  ...clientForm,
                                  infoOp: newInfoOp,
                                });
                              }}
                              searchEnabled={true}
                              width="100%"
                            />
                          </div>

                          {/* Campo Establecimientos */}
                          <div style={{ flex: "1 1 0", minWidth: "100px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              Estab.
                            </label>
                            <NumberBox
                              value={
                                clientForm.infoOp?.[index]?.establecimientos ||
                                0
                              }
                              onValueChanged={(e) => {
                                const newInfoOp = [
                                  ...(clientForm.infoOp || []),
                                ];
                                newInfoOp[index] = {
                                  ...newInfoOp[index],
                                  establecimientos: e.value || 0,
                                };
                                setClientForm({
                                  ...clientForm,
                                  infoOp: newInfoOp,
                                });
                              }}
                              width="100%"
                            />
                          </div>

                          {/* Campo Supervisor */}
                          <div style={{ flex: "1 1 0", minWidth: "100px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              Supervisor
                            </label>
                            <NumberBox
                              value={
                                clientForm.infoOp?.[index]?.supervisor || 0
                              }
                              onValueChanged={(e) => {
                                const newInfoOp = [
                                  ...(clientForm.infoOp || []),
                                ];
                                newInfoOp[index] = {
                                  ...newInfoOp[index],
                                  supervisor: e.value || 0,
                                };
                                setClientForm({
                                  ...clientForm,
                                  infoOp: newInfoOp,
                                });
                              }}
                              width="100%"
                            />
                          </div>

                          {/* Campo Promotor */}
                          <div style={{ flex: "1 1 0", minWidth: "100px" }}>
                            <label
                              style={{
                                display: "block",
                                marginBottom: "5px",
                                fontSize: "14px",
                                color: "#333",
                              }}
                            >
                              Promotor
                            </label>
                            <NumberBox
                              value={clientForm.infoOp?.[index]?.promotor || 0}
                              onValueChanged={(e) => {
                                const newInfoOp = [
                                  ...(clientForm.infoOp || []),
                                ];
                                newInfoOp[index] = {
                                  ...newInfoOp[index],
                                  promotor: e.value || 0,
                                };
                                setClientForm({
                                  ...clientForm,
                                  infoOp: newInfoOp,
                                });
                              }}
                              width="100%"
                            />
                          </div>

                          {/* Botón Agregar - Siempre visible */}
                          <div
                            onClick={agregarNuevaFila}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              padding: "4px 6px",
                              border: "2px dashed #ddd",
                              borderRadius: "4px",
                              transition: "all 0.3s ease",
                              minHeight: "32px",
                              width: "fit-content",
                              flexShrink: 0,
                              marginLeft: "5px",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor =
                                "rgb(242, 144, 23)";
                              e.currentTarget.style.backgroundColor =
                                "rgba(242, 144, 23, 0.05)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = "#ddd";
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                            }}
                          >
                            <i
                              className="dx-icon-add"
                              style={{
                                fontSize: 16,
                                color: "rgb(242, 144, 23)",
                              }}
                            />
                          </div>

                          {/* Botón Eliminar - Siempre visible si hay más de 1 fila */}
                          {(clientForm.infoOp || []).length > 1 && (
                            <div
                              onClick={() => eliminarFila(index)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                padding: "4px 6px",
                                border: "2px solid #ff4444",
                                borderRadius: "4px",
                                transition: "all 0.3s ease",
                                minHeight: "32px",
                                backgroundColor: "rgba(255, 68, 68, 0.05)",
                                width: "fit-content",
                                flexShrink: 0,
                                marginLeft: "5px",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.borderColor = "#cc0000";
                                e.currentTarget.style.backgroundColor =
                                  "rgba(255, 68, 68, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.borderColor = "#ff4444";
                                e.currentTarget.style.backgroundColor =
                                  "rgba(255, 68, 68, 0.05)";
                              }}
                            >
                              <i
                                className="dx-icon-trash"
                                style={{
                                  fontSize: 16,
                                  color: "#ff4444",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    />
                  </GroupItem>
                ))}
              </Form>
            </div>
          </ScrollView>
        </div>
      </Popup>
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={toastConfig.displayTime}
      />
      <Popup
        width={"50%"}
        height={"50%"}
        visible={showPopupDelete}
        onHiding={hideDeletePopup}
        showTitle={true}
        title="Eliminar Cliente"
        showCloseButton={true}
      >
        <ScrollView width="100%" height="100%">
          <div className="form-container text-center">
            <ExclamationDiamond className="warning_icon" />
            <h5>¿Seguro que desea eliminar este cliente?</h5>
            <p>Esta acción no puede revertirse</p>
            <div className="d-flex text-center col-md-12 button_popup">
              <Button
                onClick={deleteClient}
                className="btn btn-outline-primary"
              >
                Sí, eliminar
              </Button>
              <Button
                onClick={hideDeletePopup}
                className="btn btn-outline-secondary"
              >
                Cancelar
              </Button>
            </div>
          </div>
        </ScrollView>
      </Popup>
    </React.Fragment>
  );
}
